import { FC, useContext } from 'react';
import { Link } from '@alto-avios/alto-ui';

import { HEADER } from '../../consts';
import { pushGTMEvent } from '../../utilities';
import { CMSProviderContext } from '../services/content';

export interface HelpCentreProps {
  link: string;
  label: string;
}

export const HelpCentre: FC = () => {
  const { header } = useContext(CMSProviderContext);
  const {
    helpCentre: { label, url },
  } = header.data;

  return (
    <Link href={url} iconEndProps={false} aria-label={label} onPress={() => pushGTMEvent(HEADER, label)} size="sm" underline={false}>
      {label}
    </Link>
  );
};
